import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { InputDuration } from './input';
export const NonNullInputDuration = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { value } = props;
    return value != null ? /*#__PURE__*/ _jsx(InputDuration, {
        ...props,
        ref: ref
    }) : null;
});
NonNullInputDuration.displayName = 'NonNullInputDuration';
